import { Directive, ElementRef, Input, OnInit } from '@angular/core';
import { VisibilityService } from '@df/ui/common/visibility.service';
import { BottomPanelService } from './bottom-panel.service';
@Directive({
    standalone: true,
    selector: '[bottomPanelArea]'
})
export class BottomPanelAreaDirective implements OnInit {
    @Input()
    bottomPanelArea!: string;
    constructor(private elementRef: ElementRef, private visibilityService: VisibilityService, private bottomPanelService: BottomPanelService) { }
    ngOnInit() {
        this.visibilityService.isInView(this.elementRef).subscribe(visibile => {
            if (visibile) {
                this.bottomPanelService.onShow(this.bottomPanelArea, this);
            }
            else {
                this.bottomPanelService.onHide(this.bottomPanelArea, this);
            }
        });
    }
}
